// @todo: ret rid of hardcoded organization names
export default {
    portal_organization_52: 'Glacier-Northstar',
    portal_organization_55: 'Sount Experience',
    portal_organization_56: 'Golden Alaska',
    portal_organization_75: 'Kids Co',
    portal_organization_0: 'All',
};
